// @ts-strict

import { Component, OnInit, Input } from '@angular/core';
import { NotificationTypes, NotificationType } from '@app/core/services/global-notifications/global-notifications.model';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { TrafficSourceManagementService } from '@services/traffic-sources/traffic-source-management.service';
import { TrafficSourcesService } from '@services/traffic-sources/traffic-sources.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-traffic-source-summary',
  templateUrl: './add-traffic-source-summary.component.html',
  styleUrls: ['./add-traffic-source-summary.component.scss']
})
export class AddTrafficSourceSummaryComponent implements OnInit {
  @Input() token: string = '';
  @Input() id: number | null = null;
  @Input() url: string = '';

  public customUrl: string = '';

  public textareaValues = {
    metatag: '',
    comment: '',
    token: ''
  };
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private readonly globalNotificationsService: GlobalNotificationsService,
    private readonly trafficSourceManagementService: TrafficSourceManagementService,
    private readonly trafficSourcesService: TrafficSourcesService
  ) {}
  public verificationInformation = true;

  ngOnInit(): void {
    if (this.token) {
      this.setTextAreaValues(this.token);
    } else {
      this.verificationInformation = false;
    }
    this.trafficSourceManagementService.shareNewTrafficSourceStatus(true);
  }

  public copyToken(inputElement: HTMLTextAreaElement): void {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.showNotification('view_translations.link_copied', NotificationTypes[3]);
  }

  public checkVerification() {
    if (this.id) {
      this.trafficSourcesService.checkTrafficSourceVerification(this.id, this.customUrl).subscribe(
        res => {
          if (res?.data?.status) {
            this.showNotification('view_translations.traffic_source_verification_success', NotificationTypes[3]);
            this.activeModal.close();
          } else {
            this.showNotification('view_translations.traffic_source_verification_failed', NotificationTypes[1]);
          }
        },
        (err: HttpErrorResponse) => {
          this.showNotification('view_translations.error_occurred', NotificationTypes[1]);
        }
      );
    } else {
      this.showNotification('view_translations.error_occurred', NotificationTypes[1]);
    }
  }

  public setCustomUrl(event: any) {
    this.customUrl = event.value;
  }

  public contactSupport() {
    const state = { target: 'support' };
    this.router.navigate(['messenger'], { state });
    this.activeModal.close();
  }

  private showNotification(message: string, type: NotificationType): void {
    this.globalNotificationsService.show({
      message,
      type,
      translate: true,
      isPersistent: false,
      id: ''
    });
  }

  private setTextAreaValues(token: string): void {
    this.textareaValues.metatag = `<meta name="mylead-verification" content="${token}">`;
    this.textareaValues.comment = `<!-- mylead-verification: ${token} -->`;
    this.textareaValues.token = `${token}`;
  }
}
